module.exports = __webpack_public_path__ + "img/134273813910336_image.jpg";